export default {
  main_manager: [
    {
      action: ["show"],
      subject: ["NavProfile"],
    },
    {
      action: ["show"],
      subject: ["CurrentOnline"],
    },
  ],
  admin: [
    {
      action: ["show"],
      subject: ["NavProfile"],
    },
    {
      action: ["show"],
      subject: ["CurrentOnline"],
    },
  ],
  operator: [
    {
      action: ["show"],
      subject: ["SideBar"],
    },
    {
      action: ["show"],
      subject: ["CurrentOnline"],
    },
  ],
  beneficiary: [
    {
      action: ["show"],
      subject: ["NavProfile"],
    },
    {
      action: ["show"],
      subject: ["CurrentOnline", "NavProfile"],
    },
  ],
};
